export enum PolymorphicDeserializationKey {
  Label,
  Section,
  Menu
}
